<template>
    <!-- 停车痕列表 -->
    <div style="padding: 20px;">
        <d-query-input :options="options" @query="queryBySelect" @clear="clearQuery" width="500px"
            :pageInfo="pageInfo" />
        <el-table :data="tingcheList" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
            border stripe>
            <!--            <el-table-column label="生产单编号" width="90" align="center">
                <template slot-scope="data">
                    <a @click="goToProductDetails(data.row.productOrderId)">{{data.row.productOrderNumber}}</a>
                </template>
            </el-table-column> -->
            <el-table-column v-for="(obj,key,index) in tingcheInfoTime" :key="index" :label="obj.value" :prop="key"
                :align="obj.align" :width="obj.width" />
            <el-table-column label="工单编号" width="160" align="center">
                <template slot-scope="data">
                    <a @click="$refs.workOrderDetails.show(data.row.workOrderId)">{{data.row.workOrderNumber}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="productLableNumber" label="落布标签号" align="center" width="200px">
            </el-table-column>
            <el-table-column v-for="(obj,key,index) in tingcheInfoKeys" :key="index" :label="obj.value" :prop="key"
                :align="obj.align" :width="obj.width" />
        </el-table>
        <el-pagination style="text-align: center" background layout="prev, pager, next" @current-change="getTingcheList"
            :page-size="pageInfo.size" :current-page="pageInfo.page" :page-count="totalPages">
        </el-pagination>
        <work-order-details ref="workOrderDetails" />
    </div>
</template>

<script>
    import {
        workOrderDetails,
        dQueryInput
    } from '@/components/projectComponents'
    export default {
        components: {
            workOrderDetails,
            dQueryInput
        },
        data() {
            return {
                tingcheList: [],
                pageInfo: {
                    page: 1,
                    size: 20
                },
                tingcheInfoKeys: {
                    machineName: {
                        value: '机台(车间)',
                        align: 'center'
                    },
                    doorNumber: {
                        value: '发生门幅号',
                        align: 'center'
                    },
                    batchNumber: {
                        value: '发生批次号',
                        align: 'center'
                    },
                    lengthInBatch: {
                        value: '匹号中的米数',
                        align: 'center'
                    },
                    lengthInOrder: {
                        value: '工单中的米数',
                        align: 'center'
                    },
                    lengthInShift: {
                        value: '班次中的米数',
                        align: 'center'
                    },
                    lengthInTotal: {
                        value: '发生时总米数',
                        align: 'center'
                    },
                },
                tingcheInfoTime: {
                    sendTime: {
                        value: '发生时间',
                        align: 'center'
                    }
                },
                totalPages: 0,
                options: [{
                    label: '生产单编号',
                    value: 'productOrderNumber'
                }, {
                    label: '工单编号',
                    value: 'workOrderNumber'
                }]
            }
        },
        methods: {
            // 获取停车痕分页列表
            getTingcheList(page) {
                this.pageInfo.page = page
                this.$requestBase({
                    url: 'v1/factory/defect/tingche/page',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.tingcheList = this.formatTingcheList(res.data.list)
                    console.log(this.tingcheList)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化停车痕列表
            formatTingcheList(res) {
                res.forEach(item => {
                    item.machineName = `${item.machineNumber}(${item.machineWorkShop})`
                    item.sendTime = this.utils.timestampToTime(item.sendTime)
                    item.lengthInBatch = this.utils.toMeter(item.lengthInBatch)
                    item.lengthInOrder = this.utils.toMeter(item.lengthInOrder)
                    item.lengthInShift = this.utils.toMeter(item.lengthInShift)
                    item.lengthInTotal = this.utils.toMeter(item.lengthInTotal)
                })
                return res
            },
            // 按条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo
                this.getTingcheList(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.getTingcheList(1)
            },
            // 路由至生产单详情界面
            goToProductDetails(productOrderId) {
                this.$router.push(`productOrderList/productOrderDetalis/${productOrderId}`)
            }
        },
        created() {
            this.getTingcheList(1)
        }
    }
</script>

<style scoped lang="scss">


</style>
